// extracted by mini-css-extract-plugin
module.exports = {"container":"ApprovalHistory_container__3dIK-","name":"ApprovalHistory_name__zjQwN"};